import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon } from '@/core/constants/webComponents';
import successIllustration from '../assets/analytics-satisfaction-clean.svg';
import './CreatePanelSuccessModal.scss';

interface CreatePanelSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueEditing: () => void;
  onGoToSearch: () => void;
}

export const CreatePanelSuccessModal: React.FC<CreatePanelSuccessModalProps> = ({
  isOpen,
  onClose,
  onContinueEditing,
  onGoToSearch,
}) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="new-setup__modal-overlay">
      <dialog open className="new-setup__create-panel-success-modal" aria-labelledby="new-setup-create-panel-success-title">
        <button
          type="button"
          className="new-setup__create-panel-success-modal-close"
          onClick={onClose}
          aria-label={t('newSetup.createPanelSuccessModal.close')}
        >
          <BdsIcon theme="outline" name="close" size="medium" aria-hidden="true" />
        </button>

        <div className="new-setup__create-panel-success-modal-body">
          <span className="new-setup__create-panel-success-modal-media" aria-hidden="true">
            <span className="new-setup__create-panel-success-modal-illustration-frame" aria-hidden="true">
              <img
                src={successIllustration}
                alt={t('newSetup.createPanelSuccessModal.illustrationAlt')}
                className="new-setup__create-panel-success-modal-illustration"
              />
            </span>
          </span>

          <div className="new-setup__create-panel-success-modal-content">
            <h2 id="new-setup-create-panel-success-title" className="new-setup__create-panel-success-modal-title">
              {t('newSetup.createPanelSuccessModal.title')}
            </h2>
            <p className="new-setup__create-panel-success-modal-description">
              {t('newSetup.createPanelSuccessModal.description')}
            </p>
          </div>
        </div>

        <footer className="new-setup__create-panel-success-modal-actions">
          <button
            type="button"
            className="new-setup__create-panel-success-modal-secondary"
            onClick={onContinueEditing}
          >
            {t('newSetup.createPanelSuccessModal.continueEditing')}
          </button>

          <button
            type="button"
            className="new-setup__create-panel-success-modal-primary"
            onClick={onGoToSearch}
          >
            {t('newSetup.createPanelSuccessModal.goToSearch')}
          </button>
        </footer>
      </dialog>
    </div>
  );
};
